export const subscriptionFormContainer =
  'grid w-full grid-rows-[auto,auto] gap-x-1 gap-y-3 lg:grid-flow-col lg:grid-cols-[1fr,7rem] 2xl:gap-x-4';
export const subscriptionCheckboxContainer = 'relative w-full lg:col-span-2';
export const subscriptionFieldContainer = 'border-none text-gray-900 h-11 mb-2 sm:mb-0';
export const subscriptionButton = 'h-11';
const errorMessageClasses = 'paragraph-xs';
const labelClasses = 'paragraph-xs';

const footerSubscriptionBlogTheme = {
  subscriptionFormContainer,
  subscriptionCheckboxContainer,
  subscriptionFieldContainer,
  subscriptionButton,
  errorMessageClasses,
  labelClasses,
};

export default footerSubscriptionBlogTheme;
